import React from 'react';
import { useStore } from '../hooks/useStore';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

export default function ContactPage() {
  const { settings } = useStore();

  return (
    <div className="max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-8">Contacte-nos</h1>

      <div className="bg-white rounded-lg shadow-sm">
        {/* Contact Information */}
        <div className="p-6 space-y-6">
          {settings?.address && (
            <div className="flex items-start space-x-3">
              <MapPin className="h-5 w-5 text-primary flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-medium">Endereço</h3>
                <p className="text-gray-600">{settings.address}</p>
                {settings.district && (
                  <p className="text-gray-600">{settings.district}</p>
                )}
              </div>
            </div>
          )}

          {settings?.commercialPhone && (
            <div className="flex items-start space-x-3">
              <Phone className="h-5 w-5 text-primary flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-medium">Telefone</h3>
                <p className="text-gray-600">{settings.commercialPhone}</p>
              </div>
            </div>
          )}

          {settings?.commercialEmail && (
            <div className="flex items-start space-x-3">
              <Mail className="h-5 w-5 text-primary flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-medium">Email</h3>
                <p className="text-gray-600">{settings.commercialEmail}</p>
              </div>
            </div>
          )}

          <div className="flex items-start space-x-3">
            <Clock className="h-5 w-5 text-primary flex-shrink-0 mt-1" />
            <div>
              <h3 className="font-medium">Horário de Funcionamento</h3>
              {settings?.businessHours.isOnlineStore ? (
                <p className="text-gray-600">Loja Online - 24h/7</p>
              ) : (
                <div className="space-y-1 text-gray-600">
                  {Object.entries(settings?.businessHours || {}).map(([day, schedule]) => {
                    if (day === 'isOnlineStore') return null;
                    if (schedule.isClosed) return null;

                    const dayName = {
                      monday: 'Segunda-feira',
                      tuesday: 'Terça-feira',
                      wednesday: 'Quarta-feira',
                      thursday: 'Quinta-feira',
                      friday: 'Sexta-feira',
                      saturday: 'Sábado',
                      sunday: 'Domingo'
                    }[day];

                    return (
                      <p key={day}>
                        {dayName}: {schedule.open} - {schedule.close}
                        {schedule.lunchBreak && (
                          <span className="text-sm">
                            {' '}
                            (Almoço: {schedule.lunchBreak.start} - {schedule.lunchBreak.end})
                          </span>
                        )}
                      </p>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Contact Form */}
        <div className="border-t">
          <form className="p-6 space-y-4">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                Nome
              </label>
              <input
                type="text"
                id="name"
                name="name"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary sm:text-sm"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary sm:text-sm"
              />
            </div>

            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                Mensagem
              </label>
              <textarea
                id="message"
                name="message"
                rows={4}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary sm:text-sm"
              />
            </div>

            <button
              type="submit"
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
            >
              Enviar Mensagem
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
